module.exports = __webpack_public_path__ + "images/cb74d0935e455fa74a25dce6a83b8918.svg";